
import { getUploadPathAndToken, uploadAuthToken, getPlayBackAddress } from "@/zsm-api-new/bunchPlanting"
import {
  deleteAndCreate, createFile, deleteFile, getFile, listDataFile, updateFile,
  findFileGroup,
  delFileGroup,
  updateFileGroup,
  createFileGroup,
  updateFileGroupCodeById,
  delFileByIds
} from '@/zsm-api-new/file.js'
import { getLocalStorage } from '@/utils/auth'
import { Message } from "element-ui"
const state = {
  groupModal: false //分组弹框
}

const mutations = {

}

const actions = {

  /**
   * 批量删除素材
   * @param {String} fileIds 素材id
   * @param {String} flag 0删 1查
   * @returns 
   */
  delFileByIds({ commit }, data) {
    return new Promise((resolve, reject) => {
      delFileByIds(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  /**
   * 批量修改素材分组
   * @param {String} fileIds 素材id
   * @param {String} fileGroupCode 分组Id 
   * @returns 
   */
  updateFileGroupCodeById({ commit }, data) {
    return new Promise((resolve, reject) => {
      updateFileGroupCodeById(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  /**
 * 删除分组
 * @param {String} id 分组Id 
 * @returns 
 */
  delFileGroup({ commit }, id) {
    return new Promise((resolve, reject) => {
      delFileGroup({ id }).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },


  /**
   * 修改分组
   * @param {String} id 分组Id 
   * @param {String} name 分组名称 
   * @param {String} sort 排序 
   * @param {String} classType 分组类型 
   * @returns 
   */
  updateFileGroup({ commit }, data) {
    return new Promise((resolve, reject) => {
      updateFileGroup(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },


  /**
   * 分组查询
   * @param {String} loginCode 讲师账号 
   * @param {Number} pageNo pageNo
   * @param {Number} pageSize pageSize
   * @returns 
   */
  findFileGroup({ commit }, data) {
    return new Promise((resolve, reject) => {
      data = {
        ...data,
        loginCode: JSON.parse(JSON.parse(getLocalStorage('zsm-userInfo'))).mobile
      }
      if (!data.loginCode) {
        reject('登录账号不能为空')
        return
      }
      findFileGroup(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },


  /**
 * 创建分组
 * @param {Object} params 分组信息 
 * @returns 
 */
  createFileGroup({ commit }, data) {
    data = {
      ...data,
      loginCode: JSON.parse(JSON.parse(getLocalStorage('zsm-userInfo'))).mobile
    }
    return new Promise((resolve, reject) => {
      createFileGroup(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },


  /**
   * 获取抖音云上传地址
   * @param vId vId
   * @returns 
   */
  getPlayBackAddress({ commit }, vId) {
    return new Promise((resolve, reject) => {
      getPlayBackAddress(vId).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  /**
  * 抖音云获取上传凭证
  * @param fileUrl 文件地址
  * @returns 
  */
  uploadAuthToken({ commit }, info) {
    return new Promise((resolve, reject) => {
      uploadAuthToken(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  /**
   * 发送到抖音云
   * @param fileUrl 文件地址
   * @returns 
   */
  getUploadPathAndToken({ commit }, info) {
    return new Promise((resolve, reject) => {
      getUploadPathAndToken(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 替换素材信息
  deleteAndCreate({ commit }, info) {
    // let {id,title} =info
    return new Promise((resolve, reject) => {
      deleteAndCreate(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 修改素材信息
  updateFile({ commit }, info) {
    // let {id,title} =info
    return new Promise((resolve, reject) => {
      updateFile(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 查看素材列表
  listDataFile({ commit }, info) {
    return new Promise((resolve, reject) => {
      listDataFile(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 查看单个素材
  getFile({ commit }, info) {
    return new Promise((resolve, reject) => {
      getFile(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 新增媒体
  deleteFile({ commit }, id) {
    return new Promise((resolve, reject) => {
      deleteFile(id).then(response => {
        if (response.result == 'true') {
          resolve(response)
        } else {
          Message.error(response.message)
          reject(false)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 新增媒体
  createFile({ commit }, info) {
    return new Promise((resolve, reject) => {
      createFile(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
